/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CreateReserveResponse } from '../model';
/**
 * CreateReserveApiApiCreateReserveGet - axios parameter creator
 * 
 * @param {number} [busId] 
 * @param {number} [count] 
 * @param {number} [billId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CreateReserveApiApiCreateReserveGetAxiosParamCreator (busId?: number, count?: number, billId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CreateReserve`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (busId !== undefined) {
        localVarQueryParameter['busId'] = busId;
    }

    if (count !== undefined) {
        localVarQueryParameter['count'] = count;
    }

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiCreateReserveGet operation in CreateReserveApi.
 * @export
 * @interface CreateReserveApiApiCreateReserveGetRequest
 */
export interface CreateReserveApiApiCreateReserveGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateReserveApiApiCreateReserveGet
     */
    readonly busId?: number

    /**
     * 
     * @type {number}
     * @memberof CreateReserveApiApiCreateReserveGet
     */
    readonly count?: number

    /**
     * 
     * @type {number}
     * @memberof CreateReserveApiApiCreateReserveGet
     */
    readonly billId?: number
}

/**
* 
* @param {CreateReserveApiApiCreateReserveGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CreateReserveApiApiCreateReserveGet(requestParameters: CreateReserveApiApiCreateReserveGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CreateReserveApiApiCreateReserveGetAxiosParamCreator(requestParameters.busId, requestParameters.count, requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<CreateReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
